<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div><el-divider >导入单科成绩</el-divider></div>

        <div style="padding: 10px;">
          <div style="padding-left: 20px;color:red;font-size: 16px;">注:使用本功能必须使用系统中的模板，而且是一科成绩</div>
          <div style="padding: 10px;">

            <el-form ref="editForm" :model="editForm" label-width="80px" size="mini">
              <!--            <el-form-item label="科目名称">
              <el-input v-model="editForm.course"></el-input>
            </el-form-item> -->
              <el-form-item label="科目名称">
                <el-select v-model="editForm.course" placeholder="请选择">
                  <el-option v-for="item in courses" :key="item.course_name" :label="item.course_name" :value="item.course_name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年级班级">
                <el-input v-model="editForm.grade" placeholder="如:三年级(6)班"></el-input>
              </el-form-item>
              <el-form-item label="考试名称">
                <el-input v-model="editForm.exam" placeholder="如:第一次周考"></el-input>
              </el-form-item>
              <el-form-item label="卷面分">
                <el-input v-model="editForm.paper_score"  placeholder="如:150,不得输入负值或0,否则可能导致结果不正确"  ></el-input>
              </el-form-item>
              <el-form-item label="下载模板">
                <div><a href="http://www.sales1.top/score/files/single_course.xls" target="_blank">点击下载导入数据的模板</a></div>
              </el-form-item>
              <el-form-item label="Excel文件">
                <el-upload class="upload-demo" :http-request="uploadFile" action :on-preview="handlePreview" :on-remove="handleRemove"
                  :on-change="fileChange" :before-remove="beforeRemove" accept=".xls" multiple :limit="1" :on-exceed="handleExceed"
                  :file-list="fileList">
                  <div class="uploadFileStyle">
                     <el-button type="primary" plain>+点击上传Excel文件</el-button>
                    <div slot="tip" class="el-upload__tip" style="font-size: 18px;">只能上传从本系统下载的excel模板文件填写的成绩单</div>
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item size="large">
                <el-button size="small" type="primary" @click="uploadExcelFile">立即导入</el-button>
                <el-button @click="back">返回</el-button>
              </el-form-item>
            </el-form>

            <div>
              <div style="font-size:16px;color:red;"><a href="http://www.sales1.top/score/help/score_single_course.mp4" target="_blank">不会使用，点我观看操作视频</a></div>
            </div>
          </div>

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        }
      }
    },
    created() {
      // console.log('调用exam_list created')
      this.loadCourses()
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        // 数据校验
        if (this.editForm.course === '') {
           this.$message.error('请选择科目')
           return
        }

        if (this.editForm.grade === '') {
           this.$message.error('请输入年级和班级')
           return
        }

        if (this.editForm.exam === '') {
           this.$message.error('请输入考试名称，如：期中考试')
           return
        }

        if (this.editForm.paper_score === '') {
           this.$message.error('请输入卷面分')
           return
        }

        if (!this.isNumber(this.editForm.paper_score)) {
           this.$message.error('卷面分必须是数字')
           return
        }

        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('exam', this.editForm.exam)
        data.set('course', this.editForm.course)
        data.set('grade', this.editForm.grade)
        data.set('paperScore', this.editForm.paper_score)

        let tmpExcelFile = this.fileList[0].raw

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_upload.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log('数据导入完成！！')

          if (res.data.result === '2') {
            that.$alert('导入失败！请下载系统中模板，并按照模板要求粘贴成绩。三个必须填写的列是姓名，学号，成绩。顺序和表头的名称不能修改。')
            that.fileList = []
          } else if (res.data.result === '-1') {
            that.$message.error('长时间未操作，请登录后重新操作！')
            that.$router.push('/')
          } else {
            that.$router.push('/exam_list')
            that.$message('导入成功！')
          }

          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()
          that.$router.push('/exam_list')
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
      },
      loadCourses() {
        let that = this
        var requestUrl = '/score/web/_get_courses.jsp'

        this.axios.get(requestUrl, {
            params: {

            }
          }).then(function(response) {
            that.courses = response.data
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      back() {
        this.$router.push('/exam_list')
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam_import.vue